import type { PrimitiveAtom } from 'jotai';
import { atom } from 'jotai';

export type HashtagsType = string;

export const deadlineTimezoneAtom = atom(null) as PrimitiveAtom<string>;
export const deadlineDateTimeAtom = atom(null) as PrimitiveAtom<string>;

type OptionsAtomType = {
    hashtags: HashtagsType[];
    nb_winners: number;
    nb_extraWinners: number;
    nb_mentions: number;
    paid_comments: boolean;
    only_unique_comments: boolean;
    deadline: string;
};

export const optionsAtom = atom<OptionsAtomType>({
    hashtags: [],
    nb_winners: 1,
    nb_extraWinners: null,
    nb_mentions: null,
    paid_comments: false,
    only_unique_comments: false,
    deadline: null
});

export const emailAtom = atom('');

export const toggleDeadlineAtom = atom(false);
export const toggleAlternativeWinnersAtom = atom(false);
